import CardEvent from '@/components/card-event/CardEvent.js';

const initCardEventNew = () => {
  const elements = Array.from(document.querySelectorAll('[data-component="card-event-new"]'));

  elements.forEach((element) => {
    new CardEvent(element);
  });
};

export default initCardEventNew;
